<template>
  <div v-if="showStatsMenu" class="menu-margin">
    <v-container max-width="1400" class="px-0 bg-background">
      <v-row class="mb-4" :class="$vuetify.display.smAndDown ? 'mx-3' : 'mx-6'">
        <v-col cols="12" class="px-0">
          <h1>{{ $t('stats') }}</h1>
        </v-col>

        <v-col cols="12" class="events pt-0 px-0 border-bottom pb-0">
          <v-tabs v-model="activeSection" class="pa-0">
            <v-tab :to="`/leagues/${season.urlTitle}/${season.year}/statistics?tab=0`" :text="$t('home')" />
            <v-tab :to="`/leagues/${season.urlTitle}/${season.year}/statistics?tab=0`" :text="$t('skaters')" />
            <v-tab :to="`/leagues/${season.urlTitle}/${season.year}/statistics?tab=1`" :text="$t('goalies')" />
            <v-tab :to="`/leagues/${season.urlTitle}/${season.year}/statistics?tab=2`" :text="$t('teams')" />
          </v-tabs>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script setup lang="ts">
import { ref, watchEffect } from 'vue'
import { useRoute } from 'vue-router'

type Season = {
  _id?: string
  title?: string | null
  urlTitle?: string | null
  year?: string | number | null
  imageUrl?: string | null
}

const props = defineProps<{
  season?: Season
  showStatsMenu?: boolean
}>()

const season = {
  title: 'hockeybook.online',
  urlTitle: null,
  year: null,
  imageUrl: null,
  ...props.season,
}

const showStatsMenu = props.showStatsMenu ?? true

const route = useRoute()
const activeSection = ref(0)

// (Optional) keep tabs in sync with ?tab=
watchEffect(() => {
  const q = Number(route.query.tab ?? 0)
  activeSection.value = Number.isFinite(q) ? q : 0
})
</script>

<style scoped>
.title-section {
  max-width: 1200px;
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 10px;
  text-align: center;
  padding: 3px 0;
  font-size: 0.9rem;
}
.title-text {
  font-family: 'Aileron', sans-serif;
  font-size: 1.25rem;
  font-weight: bold;
}
.v-tab { padding: 0 20px !important; }
</style>
